var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Watch } from "vue-property-decorator";
import axios from "axios";
let MaterialList = class MaterialList extends Vue {
    search = '';
    item = {
        id: 0,
        name: ""
    };
    filter = [];
    cardBtn = "";
    cardTitel = "";
    material = [];
    name = "";
    loading = false;
    dia = false;
    page = {
        total: 0
    };
    options = {
        itemsPerPage: 20,
        page: 1,
        total: 0
    };
    text = '';
    snackbar = false;
    timeout = -1;
    color = "";
    headers = [
        { text: 'material', align: 'start', value: 'material' },
        { text: 'Aktionen', value: 'actions' },
    ];
    openCreateDia() {
        this.cardTitel = "Material erstellen";
        this.cardBtn = "Material erstellen";
        this.dia = true;
    }
    openEditDia(item) {
        this.item = item;
        this.name = item.material;
        this.cardTitel = "Material bearbeiten";
        this.cardBtn = "Material ändern";
        this.dia = true;
    }
    getMaterialList() {
        this.loading = true;
        this.setFilter('search', this.search);
        axios.get('/api/material', {
            params: {
                itemsPerPage: this.options.itemsPerPage,
                page: this.options.page,
                sortBy: this.options.sortBy.toString(),
                sortDesc: this.options.sortDesc,
                filter: this.filter,
            }
        }).then((response) => {
            this.material = response.data.data;
            this.page = response.data.meta;
            this.loading = false;
        });
        return this.material;
    }
    async edit() {
        this.item.name = this.name;
        await axios.put('/api/material/' + this.item.id, { material: this.item }).then((response) => {
            this.name = "";
            this.color = "green";
            this.text = "Das Material wurde erfolgreich geändert oder angelegt";
            this.snackbar = true;
        }).catch((error) => {
            this.color = "red";
            this.text = "Das Material wurde nicht erfolgreich geändert oder angelegt";
            this.snackbar = true;
        });
        this.clear();
    }
    clear() {
        this.item = {
            id: 0,
            name: ""
        };
        this.name = "";
        this.dia = false;
        this.snackbar = false;
    }
    async Delete(item) {
        if (confirm("Möchtest du wirklich das Material löschen?")) {
            await axios.delete('/api/material/' + item.id).then((response) => {
                this.color = "green";
                this.text = "Das Material wurde erfolgreich gelöscht";
                this.snackbar = true;
            }).catch((error) => {
                this.color = "red";
                this.text = "Das Material wird in einem Auftrag verwendet. " +
                    "Deswegen kann dieses Material nicht gelöscht werden";
                this.snackbar = true;
            });
            this.getMaterialList();
        }
    }
    filterOnlyLowerText(value, search, item) {
        return value != null &&
            search != null &&
            typeof value === 'string' &&
            value.toString().toLocaleLowerCase().indexOf(search) !== -1;
    }
    setFilter(key, value) {
        this.clearFilterByKey(key);
        if (value != -1 || value != '-1') {
            this.filter.push({ key: key, value: value });
        }
    }
    clearFilterByKey(key) {
        for (let i = 0; i < this.filter.length; i++) {
            if (this.filter[i].key == key) {
                this.filter.splice(i, 1);
            }
        }
        return false;
    }
    watchOptions() {
        this.getMaterialList();
        this.clear();
    }
    watchSearch() {
        this.getMaterialList();
        this.clear();
    }
    watchItem() {
        this.getMaterialList();
    }
    mounted() {
        if (this.$store.getters.isLoggedIn) {
            this.getMaterialList();
            this.$store.state.monitor = false;
        }
        else {
            this.$store.commit('logout');
        }
    }
};
__decorate([
    Watch('options', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MaterialList.prototype, "watchOptions", null);
__decorate([
    Watch('search'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MaterialList.prototype, "watchSearch", null);
__decorate([
    Watch('item', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MaterialList.prototype, "watchItem", null);
MaterialList = __decorate([
    Component({
        name: "MaterialList",
    })
], MaterialList);
export default MaterialList;
